import { useCallback, useState } from 'react'
import { Session } from 'next-auth'
import { Coordinates, StoreSummary } from '~/types'
import { Client } from '~/customClients/client'
import { UseStoresList } from './useStoresList.types'

export function useStoresList(): UseStoresList {
  const [stores, setStores] = useState<Array<StoreSummary>>([])
  const [isLoading, setIsLoading] = useState(false)

  const fetchStoresByLocation = useCallback(
    async (
      coordinates: Coordinates,
      session: Session,
      limit: number,
      sku: string,
      canClickAndCollect = false
    ) => {
      if (!coordinates?.latitude || !coordinates?.longitude) {
        setStores([])
        return
      }

      try {
        setIsLoading(true)
        const stores = await Client.store.getNearestStore(
          coordinates,
          session,
          limit,
          sku,
          canClickAndCollect
        )

        setIsLoading(false)
        setStores(stores.getValue() || [])
      } catch (err) {
        setIsLoading(false)
        setStores([])
      }
    },
    [setIsLoading, setStores]
  )

  const clearStores = useCallback(() => {
    setStores([])
  }, [])

  return {
    stores,
    isLoading,
    fetchStoresByLocation,
    clearStores,
  }
}
